import React, { useEffect, useState } from "react";
import { Wrapper } from "../../components/Wrapper";
import { PageTitle } from "../../components/PageTitle";
import { CustomTable } from "../../components/CustomTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Notification } from "../../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import { Preload } from "../../components/Preload";
import { DELETE_FOOTER_MENU_LINK } from "../../graphql/Mutations/FooterMenuMutation";
import { GET_FOOTER_MENU_LINKS } from "../../graphql/Queries/FooterMenuQuery";

export const Links = ({ url }) => {
  const [items, setItems] = useState([]);
  let [searchParams, setSearchParams] = useSearchParams();
  const navigator = useNavigate();
  const { loading, error, data } = useQuery(GET_FOOTER_MENU_LINKS, {
    fetchPolicy: "no-cache",
    variables: {
      footer_menu_id: Number(searchParams.get("footer_menu_id")),
    },
  });
  const [drop] = useMutation(DELETE_FOOTER_MENU_LINK);

  const remove = (id) => {
    drop({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteFooterMenuLink);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(
      `${url}/form?id=${id}&footer_menu_id=${searchParams.get(
        "footer_menu_id",
      )}`,
    );
  };

  useEffect(() => {
    if (data) {
      setItems(data.footerMenuLink);
    }
  }, [data]);

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle
        title={"Ссылки для блока"}
        breadcrumbs={[
          {
            slug: "/footer-menu",
            name: "Ссылки в футере",
          },
        ]}
      />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "title.ru", label: "Название" },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form?footer_menu_id=${searchParams.get(
                      "footer_menu_id",
                    )}`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
